module.exports = __webpack_public_path__ + "static/media/5.357b6f40.jpg";